import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { AxiosResponse } from "axios";

import isEmail from "app/helpers/isEmail";
import { IMaster } from "app/api/types";
import {
  uploadMasterImg,
  uploadMasterDiploma,
  deleteMasterDiploma,
} from "app/api/redux/Masters/actions";
import MasterServices from "./components/MasterServices";

import "./styles.scss";
import Checkbox from "../Elements/Checkbox";

interface IProps {
  master: IMaster;
  isActive: boolean;
  onSubmit: (data: IMaster) => void;
  uploadMasterImg: (data: any, masterId: number) => Promise<AxiosResponse>;
  uploadMasterDiploma: (data: any, masterId: number) => Promise<AxiosResponse>;
  deleteMasterDiploma: (name: any, masterId: number) => Promise<AxiosResponse>;
}

const EditMasterForm: React.FC<IProps> = (props) => {
  const [name, setName] = useState(props.master.name);
  const [position, setPosition] = useState(props.master.position);
  const [email, setEmail] = useState(props.master.email);
  const [label, setLabel] = useState("");
  const [labelDiploma, setLabelDiploma] = useState("");
  const [description, setDescription] = useState(
    props.master.description || ""
  );
  const [fullDescription, setFullDescription] = useState(
    props.master.fullDescription || ""
  );
  const [serviceErrorIds, setServiceErrorIds] = useState<Set<Number>>(
    new Set()
  );
  const [isEmploee, setIsEmploee] = useState(props.master.is_emploee);

  const [serviceIds, setServiceIds] = useState(props.master.serviceIds || []);

  const imgUrl = `${process.env.REACT_APP_API_HOST}/static/masters/${props.master.id}/main.jpg`;

  const [errorStyle, setErrorStyle] = useState({
    email: "",
    position: "",
    name: "",
    description: "",
    fullDescription: "",
  });

  const handleChange = (e: any) => {
    e.target.name === "name" && setName(e.target.value);
    e.target.name === "position" && setPosition(e.target.value);
    e.target.name === "email" && setEmail(e.target.value);
    e.target.name === "description" && setDescription(e.target.value);
    e.target.name === "fullDescription" && setFullDescription(e.target.value);
    e.target.name === "isEmploee" && setIsEmploee(!isEmploee);

    if (e.target.name.split("--").length > 1) {
      const targetName: string[] = e.target.name.split("--"); //отделяет id content'а от типа поля (src напр.)
      const targetValue = e.target.value;
      let obj: any = {};

      if (targetName[1] === "time") {
        let currentServiceErrorsIds = serviceErrorIds;

        if (+targetValue === 0 || +targetValue % 30 !== 0) {
          currentServiceErrorsIds.add(Number(targetName[0]));
          setServiceErrorIds(currentServiceErrorsIds);
          return;
        }
        currentServiceErrorsIds.delete(Number(targetName[0]));
        setServiceErrorIds(currentServiceErrorsIds);
      }

      const newMasterServices = serviceIds.map((item) => {
        // кто-то из них случайно может оказаться строкой
        if (Number(item.serviceId) === Number(targetName[0])) {
          obj[targetName[1]] = Number(targetValue);
          return {
            ...item,
            ...obj,
          };
        }
        return item;
      });
      setServiceIds(newMasterServices);
    }
  };

  const addService = (serviceId: number) => {
    const newService = {
      serviceId,
      time: 30,
      price: 0,
    };
    setServiceIds([...serviceIds, newService]);
  };

  const delService = (serviceId: number) => {
    let currentServiceErrorsIds = serviceErrorIds;
    const newServiceIds = serviceIds.filter(
      (item) => item.serviceId !== serviceId
    );

    serviceErrorIds.delete(serviceId);
    setServiceErrorIds(currentServiceErrorsIds);
    setServiceIds(newServiceIds);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (
      name.length > 1 &&
      email.length > 1 &&
      position.length > 1 &&
      isEmail(email) &&
      serviceErrorIds.size === 0
    )
      props.onSubmit({
        name,
        position,
        email,
        id: props.master.id,
        description,
        fullDescription,
        serviceIds,
        is_emploee: isEmploee,
      });
  };

  const handleFileUpload = (event: any) => {
    let data = new FormData();

    data.append("file", event.target.files[0]);
    data.append("filename", props.master.id?.toString() || "-1");

    props
      .uploadMasterImg(data, props.master.id || -1)
      .then((res) => setLabel("Фото загружено"))
      .catch((err) => setLabel("Фотография весит слишком много"));
  };

  const handleDiplomaUpload = (event: any) => {
    let data = new FormData();

    for (var x = 0; x < event.target.files.length; x++) {
      data.append("file", event.target.files[x]);
    }

    props
      .uploadMasterDiploma(data, props.master.id || -1)
      .then((res) => setLabelDiploma("Фото загружено"))
      .catch((err) => setLabelDiploma("Фотография весит слишком много"));
  };

  const handleDeleteDiploma = (name: string) => {
    props
      .deleteMasterDiploma(name, props.master.id!)
      .then((res) => setLabelDiploma(`Изображение ${name} удалено `))
      .catch((err) => setLabelDiploma("ОШИБКА: Диплом не удален"));
  };

  const updateImgUrl = () => {
    URL.revokeObjectURL(
      `${process.env.REACT_APP_API_HOST}/static/${props.master.id}.jpg`
    );
  };

  useEffect(() => {
    setErrorStyle({
      email: email && isEmail(email) ? "" : "edit-phrase__input_error",
      name: name && name.length > 1 ? "" : "edit-phrase__input_error",
      position:
        position && position.length > 1 ? "" : "edit-phrase__input_error",
      description:
        description && description.length > 1 ? "" : "edit-phrase__input_error",
      fullDescription:
        fullDescription && fullDescription.length > 1
          ? ""
          : "edit-phrase__input_error",
    });
  }, [email, name, position, description, fullDescription]);

  return (
    <form
      className={`edit-phrase__form ${props.isActive ? "active" : ""}`}
      onSubmit={handleSubmit}
    >
      <div className="file-upload-wrapper">
        <div>
          <label
            htmlFor={`file-upload-${props.master.id}`}
            className="custom-file-upload"
          >
            Добавить фото мастера
          </label>
          <p className="file-upload-message">{label}</p>
        </div>

        <input
          className="file-upload"
          name="file-upload"
          id={`file-upload-${props.master.id}`}
          type="file"
          onChange={handleFileUpload}
        />
        <div
          style={{
            background: `url(${imgUrl}) no-repeat`,
            height: "300px",
            width: "300px",
            backgroundSize: "contain",
          }}
        />
      </div>

      <div className="edit-master-wrapper">
        <label htmlFor="phrase" className="edit-phrase__label">
          имя
        </label>
        <input
          className={`edit-phrase__input ${errorStyle.name}`}
          type="text"
          placeholder={name}
          name="name"
          value={name}
          onChange={handleChange}
          autoComplete="off"
        />
        <label htmlFor="translation" className="edit-phrase__label">
          позиция
        </label>
        <input
          className={`edit-phrase__input ${errorStyle.position}`}
          type="text"
          placeholder={position}
          name="position"
          value={position}
          onChange={handleChange}
          autoComplete="off"
        />
        <label htmlFor="meaning" className="edit-phrase__label">
          email
        </label>
        <input
          className={`edit-phrase__input ${errorStyle.email}`}
          placeholder={email}
          name="email"
          value={email}
          onChange={handleChange}
          autoComplete="off"
        />

        <label htmlFor="description" className="edit-phrase__label">
          краткое описание
        </label>
        <textarea
          className={`edit-phrase__input ${errorStyle.description}`}
          placeholder={description}
          name="description"
          value={description}
          onChange={handleChange}
          autoComplete="off"
        />

        <label htmlFor="fullDescription" className="edit-phrase__label">
          полное описание
        </label>
        <textarea
          className={`edit-phrase__input ${errorStyle.fullDescription}`}
          placeholder={fullDescription}
          name="fullDescription"
          value={fullDescription}
          onChange={handleChange}
          autoComplete="off"
        />
      </div>
      <Checkbox
        name="isEmploee"
        className="edit-record-checkbox"
        title="НЕ отображать в таблице записи"
        checked={isEmploee}
        onChange={handleChange}
      />

      {!isEmploee && (
        <MasterServices
          onChange={handleChange}
          onAdd={addService}
          onDelete={delService}
          masterServices={serviceIds}
          serviceErrorIds={serviceErrorIds}
        />
      )}
      <div className="file-upload-wrapper">
        <div>
          <label
            htmlFor={`diploma-upload-${props.master.id}`}
            className="custom-file-upload"
          >
            Добавить дипломы
          </label>
          <p className="file-upload-message">{labelDiploma}</p>
        </div>
        <input
          className="file-upload"
          name="disploma-upload"
          id={`diploma-upload-${props.master.id}`}
          type="file"
          multiple
          onChange={handleDiplomaUpload}
        />
        <div className="courousel">
          {props.master.diplomasUrl?.map((url) => (
            <article key={url}>
              <p
                className="delete-diploma"
                onClick={() => handleDeleteDiploma(url)}
              >
                удалить
              </p>
              <div
                className="courousel__item"
                key={url}
                style={{
                  background: `url(${process.env.REACT_APP_API_HOST}/static/masters/${props.master.id}/diplomas/${url}) no-repeat`,
                  height: "100%",
                  width: "100px",
                  backgroundSize: "cover",
                }}
              ></div>
            </article>
          ))}
        </div>
      </div>

      <button className="edit-phrase__submit" onClick={updateImgUrl}>
        cохранить
      </button>
    </form>
  );
};

export default connect(null, {
  uploadMasterImg,
  uploadMasterDiploma,
  deleteMasterDiploma,
})(EditMasterForm);
